// extracted by mini-css-extract-plugin
export default {"last_action_card_wrapper":"LastActionCard_last_action_card_wrapper__uU044","action":"LastActionCard_action__IKwcm","action_card":"LastActionCard_action_card__surNK"};